import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";
import { DocumentStakeholder } from "../../../@types/documentStakeholder";
import axios from "axios";
import axiosInstance from "../../../utils/axiosConfig";

export const moveStakeholderDown = createAsyncThunk(
  "documentShow/moveStakeholderDown",
  async (stakeholder: DocumentStakeholder, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const signers = state.documentShow.signers;

      let nextStakeholder = signers.find(({ order }) => (stakeholder?.order || 0) + 1 === order);
      if (!nextStakeholder) throw new Error("El firmante no existe.");

      const currentOrder = stakeholder.order && stakeholder.order + 1;
      const firstResponse = await axiosInstance.patch(
        `${api.baseURL}documentstakeholder/${stakeholder.id}`,
        {
          order: currentOrder,
        }
      );

      const nextOrder = nextStakeholder.order && nextStakeholder.order - 1;
      const secondResponse = await axiosInstance.patch(
        `${api.baseURL}documentstakeholder/${nextStakeholder?.id}`,
        {
          order: nextOrder,
        }
      );

      return [firstResponse.data, secondResponse.data];
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
